import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import HomePage from "./components/HomePage";
import ItemsPage from "./components/ItemsPage";
import CategoriesPage from "./components/CategoriesPage";
import ItemDetailsPage from "./components/ItemDetailsPage.jsx";
import ThemeProvider from "./components/ThemeProvider.jsx";
import { initTelegram } from "./telegram-utils.js";
import { initGA, trackPageView } from "./analytics.js";

const tailwindCSS = `
  @import url('https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css');
  .line-clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .animate-spin { animation: spin 1s linear infinite; }
  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
`;

if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.innerText = tailwindCSS;
  document.head.appendChild(styleSheet);
}


export const TILES = {
  categories: { id: 'categories', title: 'Categories', description: 'Browse all available item categories', path: '/categories' },
  new: { id: 'new', title: 'New', description: 'New arrivals for the last 7 days', path: '/new' },
  specialOffers: { id: 'special-offers', title: 'Special Offers', description: 'Limited-time deals and discounted items', path: '/special-offers' },
  museum: { id: 'museum', title: 'Museum', description: 'My personal collection of items', path: '/museum' },
  archived: { id: 'archived', title: 'Archived', description: 'Sold items with my reviews', path: '/archived' },
};

function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    initTelegram();
    if (process.env.NODE_ENV === 'production') {
    	initGA();
    }
  }, []);

  useEffect(() => {
  	if (process.env.NODE_ENV === 'production') {
      trackPageView(location.pathname);
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<HomePage tiles={Object.values(TILES)} />} />

      <Route
        path="/categories"
        element={<CategoriesPage mode="active" onBack={() => navigate('/')} />}
      />
      <Route
        path="/categories/:categoryId"
        element={<ItemsPage mode="category" onBack={() => navigate('/categories')} />}
      />

      <Route
        path="/archived"
        element={<CategoriesPage mode="archived" onBack={() => navigate('/')} />}
      />
      <Route
        path="/archived/:categoryId"
        element={<ItemsPage mode="archived" onBack={() => navigate('/archived')} />}
      />

      <Route path="/new" element={<ItemsPage mode="new" onBack={() => navigate('/')} />} />
      <Route path="/special-offers" element={<ItemsPage mode="special-offers" onBack={() => navigate('/')} />} />
      <Route path="/museum" element={<ItemsPage mode="museum" onBack={() => navigate('/')} />} />

      <Route path="/items/:itemId" element={<ItemDetailsPage mode="item" />} />
      <Route path="/museum/:itemId" element={<ItemDetailsPage mode="museum" />} />

      <Route path="*" element={<HomePage tiles={Object.values(TILES)} />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
          <div className="max-w-7xl mx-auto bg-gray-100 dark:bg-gray-800 min-h-screen shadow-2xl">
            <AppRoutes />
          </div>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
